function withSubcomponents(component, subcomponents) {
  return Object.assign(component, subcomponents);
}
export { withSubcomponents };